// extracted by mini-css-extract-plugin
module.exports = {"container":"world-cup-2026-slider_container__9qk2E","button":"world-cup-2026-slider_button__fgUq7"};